import { h } from 'preact';

export const MessageIcon = () => {
	return (
		<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M16.25 8.62502C16.2526 9.61492 16.0213 10.5914 15.575 11.475C15.0458 12.5338 14.2323 13.4244 13.2256 14.047C12.2189 14.6696 11.0587 14.9996 9.875 15C8.8851 15.0026 7.90859 14.7713 7.025 14.325L2.75 15.75L4.175 11.475C3.7287 10.5914 3.49742 9.61492 3.5 8.62502C3.50046 7.44134 3.83046 6.28116 4.45304 5.27443C5.07562 4.26771 5.96619 3.4542 7.025 2.92502C7.90859 2.47872 8.8851 2.24744 9.875 2.25002H10.25C11.8133 2.33627 13.2898 2.99609 14.3969 4.10317C15.5039 5.21024 16.1638 6.68676 16.25 8.25002V8.62502Z"
				stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	);
};
